<template>
  <div class="main2-content">
    <img class="topBg-right" src="../../assets/image/esg/top2.png" alt="">
    <div class="panel-content">
      <div class="model-head flex-left">
        <div class="titleWrapper">
          <div class="model-title">
            <div>{{ num }}</div><div> {{ title }}</div><div> {{ titleEn }}</div>
            <img class="tbg" src="../../assets/image/esg/tbg3.png" alt="">
          </div>
        </div>
        <div class="btn-group  btn-group-right">
          <div class="btn" :class="{ active: index == btnIndex }" v-for="(item, index) in btn" :key="index"
               @click="handleIndex(index)">
            <div class="titel">{{ item.title }}</div>
            <div class="titleEn">{{ item.titleEn }}</div>
          </div>
        </div>
      </div>

      <!-- start 0 -->
      <div class="layout-flex">
        <div class="layout-flex-1">
          <div class="flex-head">
            <template v-if="btn[this.btnIndex].dec">
              <div class="dec" v-html="btn[this.btnIndex].dec"></div>
            </template>
            <template v-if="btn[this.btnIndex].decEn">
              <div class="decEn" v-html="btn[this.btnIndex].decEn"></div>
            </template>
          </div>
          <el-collapse v-model="activeNames" accordion>
            <el-collapse-item v-for="(item, index) in btn[this.btnIndex].list" :key="index" :name="index">
              <template slot="title">{{ item.title }} {{ item.titleEn }}</template>
              <div class="collapse-scroll" style="height: auto">
                <template v-if="item.dec">
                  <div v-html="item.dec" class="dec"></div>
                </template>
                <template v-if="item.decEn">
                  <div v-html="item.decEn" class="decEn"></div>
                </template>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="layout-flex-2">
          <img :src="btn[this.btnIndex].img" style="width: 100%" />
        </div>
      </div>
    </div>
    <img class="bottomBg" src="../../assets/image/esg/bottom2.png" alt="">
  </div>
</template>

<script>
// import { csvw_url } from "../../components/config";
import config from "./config5";
export default {
  components: {},
  data() {
    return {
      ...config,
      btnIndex: 0,
      activeNames:0,
    };
  },
  beforeMount() { },
  mounted() {
  },
  methods: {
    layoutShow(val = 0) {
      if (val == this.btnIndex) {
        return true;
      } else {
        return false;
      }
    },
    handleIndex(index) {
      this.activeNames = 0;
      this.btnIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./common.less");
// 主题颜色
@colorValue: #144E82;
@bgValue: #318ADD;
@tabValue: #64D2B3;
// 描述字体颜色
@fontValue: #666666;
// 按钮激活字体颜色
@activeValue: #ffffff;

/deep/.el-collapse-item__header {
  color: @fontValue;
}
.collapse-scroll {
  color: @fontValue;
}
.main2-content {
  color: @fontValue;
}
.model-head {
  .model-title {
    color: @colorValue;
    background: linear-gradient(to right, rgba(247,252,255,0.5), #EBF6FF);
  }
  .btn-group {
    .btn {
      color: #000;
      background: #fff;
    }
    .btn.active {
      color: #fff;
      background: linear-gradient(to right, #3D7BC1 100%, #205897 100%);
    }
  }
}
/deep/ul li {
  position: relative;
  line-height: 1.769;
}

/deep/ul li::before {
  content: ""; /* 或使用 \2022 等 Unicode */
  width: 10px;height: 10px;
  background: @colorValue;border-radius: 100%;
  display: inline-block;
  margin-right: 7px;
}
</style>
